export const RolesStore = {
  data: {
    roles: [
      { id: 'SystemAdmin', displayName: 'System Admin' },
      { id: 'FleetManager', displayName: 'Fleet Manager' },
      { id: 'WorkshopManager', displayName: 'Workshop Manager' },
      { id: 'Operations', displayName: 'Operations' },
      { id: 'DataEntryClerk', displayName: 'Data Entry Clerk' },
      { id: 'Driver', displayName: 'Driver' },
      { id: 'Technician', displayName: 'Technician' },
      { id: 'Apprentice', displayName: 'Apprentice' },
      { id: 'GeneralUser', displayName: 'General User' },
    ]
  }
};
